import React from 'react'
import HorizontalScroll from "react-scroll-horizontal";
import Image from 'next/image'

export const Story = ({title}) => {

    if (title.length > 10) {
        title = title.substring(0, 10) + "...";
    }

    return (
        <div className="story">
            <button type="button" className="logo" onClick={() => setShowSidebar(false)}>
            
                    <img src="/assets/mega-logo.png" alt="logo" className='logo-image'/>
 
            </button>
            <span className="accountName">{title}</span>
        </div>
    );
}

const HorizontalIcons = () => {
    return (
        <div className="stories">
            <HorizontalScroll className="scroll">
                <Story title={"Estintori"}/>
                <Story title={"Idranti"}/>
                <Story title={"Idranti"}/>
                <Story title={"Idranti"}/>
                <Story title={"Idranti"}/>
                <Story title={"Idranti"}/>
                <Story title={"Idranti"}/>
                <Story title={"Idranti"}/>
                <Story title={"Idranti"}/>
                <Story title={"Idranti"}/>


            </HorizontalScroll>
        </div>
    )
}

export default HorizontalIcons
